import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Button, Popover } from "@mui/material";
import CoreFilterButtonIcon from "../../../../../app/core/components/CoreFilterButtonIcon/CoreFilterButtonIcon";
import CoreSelectObjArr from "../../../../../app/core/components/CoreSelect/CoreSelectObjArr";
import StudioFilter from "../../../../../app/core/components/UserFilter/StudioFilter";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import { useTranslation } from "react-i18next";
import UserFilter from "../../../../../app/core/components/UserFilter/UserFilter";
import { ROLE } from "../../../../../utils/constants/profiles";
import { generateAnniDiRiferimento } from "../../../../../utils/functions/date-utils";
import PriorityHighRoundedIcon from "@mui/icons-material/PriorityHighRounded";

const YEARS_FOR_SELECT = () => {
  const currentYear = new Date().getFullYear();
  const yearsAvailable = [];
  for (let adder = -5; adder < 3; adder++) {
    yearsAvailable.push({
      value: currentYear + adder,
      label: (currentYear + adder).toString(),
    });
  }
  return yearsAvailable;
};
const GestioneDocumentFilter = ({
  setFilter,
  selectedUser,
  setSelectedUser,
  userList,
  setDebouncedInputUserValue,
  isUsersLoading,
  setPage,
  studios,
  setDebouncedInputStudioValue,
  operators,
  isOperatorsLoading,
  setDebouncedInputOperatorValue,
  setRemoveFilterCallback,
}) => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const role = useSelector((state) => state.app.role);
  const [studio, setStudio] = useState();
  const [selectedOperator, setSelectedOperator] = useState();
  const [selectedYear, setSelectedYear] = useState("");

  const [formData, setFormData] = useState({
    mainCategoryId: "",
    subCategoryId: "",
    studioId: "",
    adminId: "",
    status: "",
    companyId: "",
    practiceId: "",
    dateFrom: "",
    dateTo: "",
    read: {},
    referenceYear: "",
  });

  /*   useEffect(() => {
    setFormData(filter);
  }, [filter]); */

  useEffect(() => {
    handleFilter();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData]);

  const statusOptions = [
    { label: t("ToValidate"), value: 3 },
    { label: t("Validateds"), value: 5 },
    { label: t("Discardeds"), value: 6 },
  ];

  //POPOVER HANDLERS
  const handleOpenPopover = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClosePopover = () => {
    setAnchorEl(null);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleImportanceChange = () => {
    formData.read.filter
      ? setFormData({
          ...formData,
          read: {},
        })
      : setFormData({
          ...formData,
          read: {
            filterType: "bool",
            type: "equals",
            filter: true,
          },
        });
  };

  const handleFilter = () => {
    setFilter(formData);
  };

  const handleReset = () => {
    setFormData({
      mainCategoryId: "",
      subCategoryId: "",
      studioId: "",
      adminId: "",
      status: "",
      companyId: "",
      practiceId: "",
      dateFrom: "",
      dateTo: "",
      read: {},
      referenceYear: "",
    });
    setFilter({
      mainCategoryId: "",
      subCategoryId: "",
      studioId: "",
      adminId: "",
      status: "",
      companyId: "",
      practiceId: "",
      dateFrom: "",
      dateTo: "",
      read: {},
      referenceYear: "",
    });

    setSelectedYear("");
    setStudio();
    setSelectedOperator();
  };

  useEffect(() => {
    if (selectedYear)
      setFormData({
        ...formData,
        dateFrom: new Date(selectedYear, 0, 1).toISOString(),
        dateTo: new Date(selectedYear, 11, 32).toISOString(),
      });
    else {
      setFormData({
        ...formData,
        dateFrom: "",
        dateTo: "",
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedYear]);

  useEffect(() => {
    if (studio?.id)
      setFormData({
        ...formData,
        studioId: studio?.id,
      });
    else
      setFormData({
        ...formData,
        studioId: "",
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [studio?.id]);

  useEffect(() => {
    if (selectedOperator?.id)
      setFormData({
        ...formData,
        adminId: selectedOperator?.id,
      });
    else
      setFormData({
        ...formData,
        adminId: "",
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOperator?.id]);

  useEffect(() => {
    setRemoveFilterCallback(() => (f) => {
      let newFormData = { ...formData };

      Object.entries(newFormData).forEach(([k, v]) => {
        if (v === f) {
          newFormData[k] = "";
          if (k === "dateTo") {
            newFormData["dateFrom"] = "";
          }
        }
      });

      setFormData(newFormData);
    });
  }, [formData, setRemoveFilterCallback]);

  return (
    <div>
      <CoreFilterButtonIcon onOpen={handleOpenPopover} />
      <Popover
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClosePopover}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{ sx: { borderRadius: "8px", marginTop: "5px" } }}
      >
        <div className="w-[32rem] p-4">
          <form>
            <div className="flex flex-col ">
              <h3 className="m-2">{t("User")}</h3>
              <UserFilter
                selectedUser={selectedUser}
                setSelectedUser={setSelectedUser}
                usersList={userList}
                setDebouncedInputUserValue={setDebouncedInputUserValue}
                isUsersLoading={isUsersLoading}
                setPage={setPage}
              />
            </div>
            {role === ROLE.ADMIN && (
              <div className="flex flex-col ">
                <h3 className="m-2">{t("Studio")}</h3>
                <StudioFilter
                  selectedUser={studio}
                  setSelectedUser={setStudio}
                  usersList={studios?.Data?.items}
                  setDebouncedInputUserValue={setDebouncedInputStudioValue}
                  startAdornment={
                    <>
                      <SearchRoundedIcon size={20} />
                    </>
                  }
                />
              </div>
            )}
            <div className="flex flex-col ">
              <h3 className="m-2">{t("Operator")}</h3>
              <UserFilter
                selectedUser={selectedOperator}
                setSelectedUser={(e) => {
                  setSelectedOperator(e);
                }}
                usersList={operators?.Data?.items || []}
                setDebouncedInputUserValue={setDebouncedInputOperatorValue}
                isUsersLoading={isOperatorsLoading}
                externalLabel={t("BriefSearchOperator")}
                externalPlaceholder={t("ExtSearchOperator")}
                externalNegativeLabel={t("NoOperatorFound")}
                startAdornment={
                  <>
                    <SearchRoundedIcon size={20} />
                  </>
                }
              />
            </div>
            <div className="flex flex-col ">
              <h3 className="m-2">Anno, Riferimento Fiscale e Stato</h3>
              <div className="grid grid-cols-3">
                <CoreSelectObjArr
                  label="Anno documento"
                  value={selectedYear}
                  items={YEARS_FOR_SELECT()}
                  onChange={(e) => setSelectedYear(e.target.value)}
                />
                <CoreSelectObjArr
                  name="referenceYear"
                  label={t("ReferenceYear")}
                  value={formData.referenceYear}
                  items={generateAnniDiRiferimento(
                    new Date().getFullYear() - 4,
                    new Date().getFullYear() + 6
                  )}
                  onChange={handleInputChange}
                  className={"px-2"}
                />
                <CoreSelectObjArr
                  name="status"
                  label={t("DocStatus")}
                  value={formData.status}
                  items={statusOptions}
                  onChange={handleInputChange}
                />
              </div>
            </div>
            <div className="flex w-full items-center justify-between">
              <h3 className="mb-2 ">{t("FilterImportantDoc")}</h3>

              <Button
                variant="outlined"
                className={`
                      ${
                        formData.read?.filter
                          ? "text-red-700 border-red-700"
                          : "text-gray border-gray"
                      }
                    `}
                onClick={handleImportanceChange}
                startIcon={<PriorityHighRoundedIcon />}
              >
                {t("ImportantDoc")}
              </Button>
            </div>
            {/* <div className="flex flex-col ">
              <h3 className="mb-2 ">{t("Category")}</h3>
              <CoreSelectObjArr
                name="mainCategoryId"
                label={t("MacroCategory")}
                value={formData.mainCategoryId}
                items={macroCategories || []}
                onChange={handleMacroChange}
              />
              <CoreSelectObjArr
                name="subCategoryId"
                label={t("SubCategory")}
                value={formData.subCategoryId}
                items={subCategories || []}
                onChange={handleInputChange}
              />
            </div> */}
            <div className="flex space-x-4 justify-center">
              <Button
                className="bg-red-700 text-white w-full"
                onClick={handleReset}
                sx={{ marginTop: "16px" }}
              >
                Reset
              </Button>
            </div>
          </form>
        </div>
      </Popover>
    </div>
  );
};

export default GestioneDocumentFilter;
